function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint consistent-return: 0 */

export function sdrn(id) {
  if (id) {
    return 'sdrn:schibsted:client:' + id;
  }
}
/** */


/**
 * Differences from the old SDK:
 *
 * + field `url` not included in `provider` any more. Not specified in schema.
 *
 */

export default function provider(input) {
  var _ref = input || {},
      providerData = _ref.provider;

  var id = providerData.id,
      _providerData$type = providerData.type,
      type = _providerData$type === undefined ? 'Organization' : _providerData$type,
      rest = _objectWithoutProperties(providerData, ['id', 'type']);

  return Object.assign({
    '@type': type,
    '@id': sdrn(id)
  }, rest);
}

export function defaultValue() {}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/provider.js
// module id = 531
// module chunks = 0